module.exports = __webpack_public_path__ + "static/media/bt_top_interestcheck_normal.6e981115.png";